<template>
  <!-- modal password reset, informing the confirmation of the password change email sent to the user -->
  <div
    class="modal"
    data-keyboard="false"
    data-backdrop="static"
    role="dialog"
    id="resetPasswordModal"
    aria-hidden="true"
  >
    <div class="modal-dialog" style="margin-top: 10%">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Redefinição de senha</h4>
          <button
            type="button"
            id="closeResetModal"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          Encaminharemos um e-mail para que possa redefinir sua senha!
          <div class="access-center">
            <button
              class="btn btn-lg access"
              id="sendResetModal"
              type="submit"
              @click="sendResetPassword()"
            >
              Encaminhar
            </button>
            <br /><br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "ResetPasswordModal",

  data() {
    return {};
  },
  mounted() {},
  props: ["userId"],
  methods: {
    sendResetPassword: function () {
      axios
        .post(`${process.env.API_PBM}/user/firstAccess/sendMail/${this.userId}`)
        .then((response) => {
          $("#resetPasswordModal").modal("hide");


          Vue.$toast.success("Email encaminhado com sucesso!", {
            position: "top-right",
            duration: 5000,
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal {
  color: rgb(100, 95, 95);
}

.modal-content {
  padding: 30px;
}

.access {
  color: #fff;
  width: 30%;
  margin-top: 40px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  text-decoration: none;
  margin-bottom: -20px;
  padding-bottom: 5px;
}
.access-center {
  text-align: center;
}
@media only screen and (max-width: 900px) {
  .text-join {
    color: rgb(100, 95, 95);
    font-size: 20px;
    margin-left: 31%;
  }

  h4 {
    font-size: 18px;
  }

  .modal-body {
    font-size: 15px;
    color: grey;
  }

  .modal-dialog {
    margin-top: 50% !important;
  }
  .access {
  color: #fff;
  width: 50%;
  margin-top: 40px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  text-decoration: none;
  margin-bottom: -20px;
  padding-bottom: 5px;
}
}

@media only screen and (max-device-width: 480px) {
  /* styles for mobile browsers smaller than 480px; (iPhone) */
  .modal-dialog {
    margin-left: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/components/user/reset/ResetPasswordModal.vue